import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { StateProvider } from "../contextApi/index"
import BankingLayout from "./body/bankingLayout.js"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"

const Layout = ({ children }) => {
  const location = useLocation()
  const [showCookie, setShowCookie] = useState(false)
  const [show, setShow] = useState(false)
  const initialState = {
    mobile: false,
    error: false,
    waitlistForm: false,
    success: {
      message: "",
      status: false,
      header: "",
      button: "",
    },
  }

  const [locationState, setLocation] = useState("")
  const countryPathname = () => {
    const pathName = location.pathname
    setLocation(pathName)
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "CHANGE_MOBILE":
        return {
          ...state,
          mobile: action.newMobile,
        }
      case "CHANGE_ERROR":
        return {
          ...state,
          error: action.newPayload,
        }
      case "CHANGE_SUCCESS_MODAL":
        return {
          ...state,
          success: action.newPayload,
        }
      case "CHANGE_API_MODAL":
        return {
          ...state,
          [action.key]: action.value,
          [`${action.key}Payload`]: action.newPayload,
        }
      case "CHANGE_VIEW_MODALS":        
        return {
          ...state,
          [action.key]: action.value,
          bvnErrorMsg: action.message
        }
        
      default:
        return state
    }
  }

  const closeCookie = () => {
    setShowCookie(false)
    localStorage.setItem("kuda-privacy-accepted", true)
    document.body.classList.remove("cookie-init")
  }

  useEffect(() => {
    let cookieValue = localStorage.getItem("kuda-privacy-accepted")
    if (!cookieValue) {
      setShowCookie(true)
      document.body.classList.add("cookie-init")
    } else {
      setShowCookie(false)
      document.body.classList.remove("cookie-init")
    }
  }, [])

  useEffect(() => {
    const pathName = location.pathname
    countryPathname()
    if (
      locationState.includes("/uk")
    ) {
      setLocation(pathName)
      setShow(true)
    }
  }, [locationState])

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <BankingLayout children={children} />
        <>
          {showCookie && (
            <div className="kuda-cookie--badge flex align-center">
              <p>
                By using this website you agree to our{" "}
                {show ?
                  <Link to="/en-gb/legal/cookie-policy/" className="link-decoration color-primary">
                    cookie policy
                  </Link> :
                  <Link to="/en-ng/legal/cookie-policy/" className="link-decoration color-primary">
                    cookie policy
                  </Link>}
                .
              </p>{" "}
              <span className="kuda-cta" onClick={closeCookie}>
                Dismiss
              </span>
            </div>
          )}
        </>
    </StateProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
